"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "santo-stefano-roero": {
    "8684e618": [{
      "hkey": "8422e2d9",
      "slug": "santo-stefano-roero",
      "name": "Santo Stefano Roero",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele": [{
      "hkey": "8422e2d9",
      "slug": "santo-stefano-roero",
      "name": "Santo Stefano Roero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e6bfaa1b": [{
      "hkey": "8422e2d9",
      "slug": "santo-stefano-roero",
      "name": "Santo Stefano Roero",
      "primary": true,
      "skipSearch": false
    }],
    "sant-antonio": [{
      "hkey": "8422e2d9",
      "slug": "santo-stefano-roero",
      "name": "Santo Stefano Roero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ef3e666f": [{
      "hkey": "f3692dad",
      "slug": "valle-dei-lunghi-ss-trinita",
      "name": "Valle dei lunghi-SS. Trinità",
      "primary": true,
      "skipSearch": false
    }],
    "ss-trinita": [{
      "hkey": "f3692dad",
      "slug": "valle-dei-lunghi-ss-trinita",
      "name": "Valle dei lunghi-SS. Trinità",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;